module.exports = __webpack_public_path__ + "static/media/logo_white.b8149c3c.svg";